// utils/yandexMetrika.js

// ID вашего счетчика
const COUNTER_ID = 99942553;

// Проверка доступности метрики
const isMetrikaAvailable = () => {
  return typeof window !== 'undefined' && window.ym;
};

// Безопасная обертка для вызовов метрики
const safeMetrikaCall = (callback) => {
  if (isMetrikaAvailable()) {
    try {
      callback();
    } catch (error) {
      console.error('Ошибка Яндекс.Метрики:', error);
    }
  }
};

// Отслеживание целей
export const trackGoal = (goalName, params = {}) => {
  safeMetrikaCall(() => {
    window.ym(COUNTER_ID, 'reachGoal', goalName, params);
    console.log(`Цель отправлена: ${goalName}`, params);
  });
};

// Отслеживание событий
export const trackEvent = (category, action, label = null, value = null) => {
  safeMetrikaCall(() => {
    const eventParams = {
      event_category: category,
      event_action: action,
    };
    
    if (label) eventParams.event_label = label;
    if (value) eventParams.value = value;
    
    window.ym(COUNTER_ID, 'params', eventParams);
    console.log('Событие отправлено:', eventParams);
  });
};

// Отслеживание переходов между страницами
export const trackPageView = (url, options = {}) => {
  safeMetrikaCall(() => {
    window.ym(COUNTER_ID, 'hit', url, options);
  });
};

// Отслеживание внешних ссылок
export const trackOutboundLink = (url, callback) => {
  safeMetrikaCall(() => {
    window.ym(COUNTER_ID, 'extLink', url);
  });
  
  // Выполняем callback через небольшую задержку
  if (callback) {
    setTimeout(callback, 200);
  }
};

// Отслеживание скачивания файлов
export const trackFileDownload = (fileUrl) => {
  safeMetrikaCall(() => {
    window.ym(COUNTER_ID, 'file', fileUrl);
  });
};

// Отслеживание электронной коммерции (для будущего)
export const trackEcommerce = (action, data) => {
  safeMetrikaCall(() => {
    window.ym(COUNTER_ID, 'ecommerce', action, data);
  });
};

// Список целей для удобства
export const GOALS = {
  // Формы
  FORM_SUBMIT: 'form_submit',
  FORM_OPEN: 'form_open',
  FORM_FILL_START: 'form_fill_start',
  
  // Услуги
  SERVICE_VIEW: 'service_view',
  SERVICE_CLICK: 'service_click',
  
  // Контакты
  PHONE_CLICK: 'phone_click',
  WHATSAPP_CLICK: 'whatsapp_click',
  EMAIL_CLICK: 'email_click',
  ADDRESS_CLICK: 'address_click',
  
  // Навигация
  MENU_CLICK: 'menu_click',
  SCROLL_TO_FORM: 'scroll_to_form',
  
  // Вовлеченность
  PAGE_SCROLL_25: 'page_scroll_25',
  PAGE_SCROLL_50: 'page_scroll_50',
  PAGE_SCROLL_75: 'page_scroll_75',
  PAGE_SCROLL_100: 'page_scroll_100',
  TIME_ON_PAGE_30: 'time_on_page_30',
  TIME_ON_PAGE_60: 'time_on_page_60',
};

// Инициализация отслеживания глубины прокрутки
export const initScrollTracking = () => {
  let scrollPercentages = [25, 50, 75, 100];
  let reachedPercentages = new Set();
  
  const checkScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollPercent = Math.round((scrollTop + windowHeight) / documentHeight * 100);
    
    scrollPercentages.forEach(percentage => {
      if (scrollPercent >= percentage && !reachedPercentages.has(percentage)) {
        reachedPercentages.add(percentage);
        trackGoal(`PAGE_SCROLL_${percentage}`, { scroll_depth: percentage });
      }
    });
  };
  
  // Debounce для оптимизации
  let scrollTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(checkScroll, 100);
  });
};

// Инициализация отслеживания времени на странице
export const initTimeTracking = () => {
  const timeGoals = [
    { seconds: 30, goal: GOALS.TIME_ON_PAGE_30 },
    { seconds: 60, goal: GOALS.TIME_ON_PAGE_60 }
  ];
  
  timeGoals.forEach(({ seconds, goal }) => {
    setTimeout(() => {
      trackGoal(goal, { time_on_page: seconds });
    }, seconds * 1000);
  });
};